/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface DisableAzureMonitoringRequest {
    tenantId: string;
    sessionId?: string;
}

export interface DisablePrometheusMonitoringRequest {
    tenantId: string;
    sessionId?: string;
}

export interface EnableAzureMonitoringRequest {
    tenantId: string;
    instrumentationKey: string;
    connectionString: string;
    sessionId?: string;
}

export interface EnableHybridMonitoringRequest {
    tenantId: string;
    instrumentationKey: string;
    connectionString: string;
    sessionId?: string;
}

export interface EnablePrometheusMonitoringRequest {
    tenantId: string;
    sessionId?: string;
}

export interface GetAvailableMonitoringOptionsRequest {
    sessionId?: string;
}

export interface GetMonitoringConfigurationRequest {
    tenantId: string;
    sessionId?: string;
}

export interface GetMonitoringStatusRequest {
    tenantId: string;
    sessionId?: string;
}

export interface MigrateMonitoringSystemRequest {
    tenantId: string;
    fromType: string;
    toType: string;
    sessionId?: string;
}

export interface TestMonitoringConnectivityRequest {
    tenantId: string;
    monitoringType: string;
    sessionId?: string;
}

export interface UpdateMonitoringConfigurationRequest {
    tenantId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * MonitoringConfigurationApi - interface
 * 
 * @export
 * @interface MonitoringConfigurationApiInterface
 */
export interface MonitoringConfigurationApiInterface {
    /**
     * Disable Azure Monitor and Application Insights for a tenant
     * @summary Disable Azure Monitor
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    disableAzureMonitoringRaw(requestParameters: DisableAzureMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Disable Azure Monitor and Application Insights for a tenant
     * Disable Azure Monitor
     */
    disableAzureMonitoring(requestParameters: DisableAzureMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Disable Prometheus monitoring for a tenant
     * @summary Disable Prometheus monitoring
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    disablePrometheusMonitoringRaw(requestParameters: DisablePrometheusMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Disable Prometheus monitoring for a tenant
     * Disable Prometheus monitoring
     */
    disablePrometheusMonitoring(requestParameters: DisablePrometheusMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Enable Azure Monitor and Application Insights for a tenant
     * @summary Enable Azure Monitor
     * @param {string} tenantId Tenant ID
     * @param {string} instrumentationKey Application Insights instrumentation key
     * @param {string} connectionString Azure Monitor connection string
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    enableAzureMonitoringRaw(requestParameters: EnableAzureMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Enable Azure Monitor and Application Insights for a tenant
     * Enable Azure Monitor
     */
    enableAzureMonitoring(requestParameters: EnableAzureMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Enables hybrid monitoring for a tenant, combining both Azure Monitor and Prometheus systems.  ### What Hybrid Monitoring Provides:  ** Best of Both Worlds:** - Azure Monitor for APM, distributed tracing, and smart detection - Prometheus for detailed metrics, Kubernetes integration, and Grafana dashboards - Unified monitoring strategy with configurable primary system  ** Metrics Routing:** - Application metrics sent to both systems simultaneously - Configurable primary monitoring system for alerting - Support for gradual migration between systems  ** Migration Support:** - Phase 1: Enable both systems in parallel - Phase 2: Migrate dashboards and alerting - Phase 3: Disable legacy system  ### Configuration Applied:  This endpoint automatically configures: 1. **Azure Monitor**: Enabled with provided credentials 2. **Prometheus**: Enabled with default settings (/actuator/prometheus, 30s scrape) 3. **Hybrid Settings**: Primary monitoring set to Prometheus, metrics routing to both  ### Prerequisites:  - Valid Azure Application Insights resource - Instrumentation key and connection string from Azure portal - Prometheus server configured to scrape the application 
     * @summary Enable hybrid monitoring
     * @param {string} tenantId Unique identifier of the tenant to configure hybrid monitoring for
     * @param {string} instrumentationKey Application Insights instrumentation key from Azure portal. Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx Found in: Azure Portal → Application Insights → Overview → Instrumentation Key 
     * @param {string} connectionString Azure Monitor connection string containing instrumentation key and ingestion endpoint. Format: InstrumentationKey&#x3D;xxx;IngestionEndpoint&#x3D;https://xxx;LiveEndpoint&#x3D;https://xxx Found in: Azure Portal → Application Insights → Overview → Connection String 
     * @param {string} [sessionId] Session ID for authorization and audit tracking. Can be provided via query parameter or X-SessionID header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    enableHybridMonitoringRaw(requestParameters: EnableHybridMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Enables hybrid monitoring for a tenant, combining both Azure Monitor and Prometheus systems.  ### What Hybrid Monitoring Provides:  ** Best of Both Worlds:** - Azure Monitor for APM, distributed tracing, and smart detection - Prometheus for detailed metrics, Kubernetes integration, and Grafana dashboards - Unified monitoring strategy with configurable primary system  ** Metrics Routing:** - Application metrics sent to both systems simultaneously - Configurable primary monitoring system for alerting - Support for gradual migration between systems  ** Migration Support:** - Phase 1: Enable both systems in parallel - Phase 2: Migrate dashboards and alerting - Phase 3: Disable legacy system  ### Configuration Applied:  This endpoint automatically configures: 1. **Azure Monitor**: Enabled with provided credentials 2. **Prometheus**: Enabled with default settings (/actuator/prometheus, 30s scrape) 3. **Hybrid Settings**: Primary monitoring set to Prometheus, metrics routing to both  ### Prerequisites:  - Valid Azure Application Insights resource - Instrumentation key and connection string from Azure portal - Prometheus server configured to scrape the application 
     * Enable hybrid monitoring
     */
    enableHybridMonitoring(requestParameters: EnableHybridMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Enable Prometheus monitoring for a tenant
     * @summary Enable Prometheus monitoring
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    enablePrometheusMonitoringRaw(requestParameters: EnablePrometheusMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Enable Prometheus monitoring for a tenant
     * Enable Prometheus monitoring
     */
    enablePrometheusMonitoring(requestParameters: EnablePrometheusMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns comprehensive information about all available monitoring options and their capabilities.  This endpoint provides a detailed overview of each monitoring type, including: - Feature descriptions and capabilities - Configuration requirements - Use case recommendations - Integration prerequisites  Use this endpoint to understand which monitoring approach best fits your needs before configuring monitoring for a tenant. 
     * @summary Get available monitoring options
     * @param {string} [sessionId] Session ID for authorization and audit tracking. Can be provided via query parameter or X-SessionID header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    getAvailableMonitoringOptionsRaw(requestParameters: GetAvailableMonitoringOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Returns comprehensive information about all available monitoring options and their capabilities.  This endpoint provides a detailed overview of each monitoring type, including: - Feature descriptions and capabilities - Configuration requirements - Use case recommendations - Integration prerequisites  Use this endpoint to understand which monitoring approach best fits your needs before configuring monitoring for a tenant. 
     * Get available monitoring options
     */
    getAvailableMonitoringOptions(requestParameters: GetAvailableMonitoringOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves the complete monitoring configuration for a specific tenant.  This endpoint returns all monitoring configurations including Azure Monitor, Prometheus, Hybrid, and Telemetry settings. The configuration determines which monitoring systems are active and how they collect metrics from the application.  ### Configuration Types Returned: - **azure**: Azure Monitor and Application Insights configuration - **prometheus**: Prometheus metrics collection configuration - **hybrid**: Combined monitoring system configuration - **telemetry**: Custom telemetry and business metrics configuration  ### Configuration Inheritance: The returned configuration follows inheritance rules: 1. System-wide defaults (if no tenant-specific config exists) 2. Tenant-specific overrides (if configured) 3. Effective configuration (computed result) 
     * @summary Get monitoring configuration
     * @param {string} tenantId Unique identifier of the tenant whose monitoring configuration to retrieve
     * @param {string} [sessionId] Session ID for authorization and audit tracking. Can be provided via query parameter or X-SessionID header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    getMonitoringConfigurationRaw(requestParameters: GetMonitoringConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Retrieves the complete monitoring configuration for a specific tenant.  This endpoint returns all monitoring configurations including Azure Monitor, Prometheus, Hybrid, and Telemetry settings. The configuration determines which monitoring systems are active and how they collect metrics from the application.  ### Configuration Types Returned: - **azure**: Azure Monitor and Application Insights configuration - **prometheus**: Prometheus metrics collection configuration - **hybrid**: Combined monitoring system configuration - **telemetry**: Custom telemetry and business metrics configuration  ### Configuration Inheritance: The returned configuration follows inheritance rules: 1. System-wide defaults (if no tenant-specific config exists) 2. Tenant-specific overrides (if configured) 3. Effective configuration (computed result) 
     * Get monitoring configuration
     */
    getMonitoringConfiguration(requestParameters: GetMonitoringConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Get current monitoring status for a tenant
     * @summary Get monitoring status
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    getMonitoringStatusRaw(requestParameters: GetMonitoringStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get current monitoring status for a tenant
     * Get monitoring status
     */
    getMonitoringStatus(requestParameters: GetMonitoringStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Migrate from one monitoring system to another
     * @summary Migrate monitoring system
     * @param {string} tenantId Tenant ID
     * @param {string} fromType Current monitoring type
     * @param {string} toType Target monitoring type
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    migrateMonitoringSystemRaw(requestParameters: MigrateMonitoringSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Migrate from one monitoring system to another
     * Migrate monitoring system
     */
    migrateMonitoringSystem(requestParameters: MigrateMonitoringSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Test connectivity for a specific monitoring type
     * @summary Test monitoring connectivity
     * @param {string} tenantId Tenant ID
     * @param {string} monitoringType Monitoring type to test
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    testMonitoringConnectivityRaw(requestParameters: TestMonitoringConnectivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Test connectivity for a specific monitoring type
     * Test monitoring connectivity
     */
    testMonitoringConnectivity(requestParameters: TestMonitoringConnectivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update monitoring configuration for a tenant
     * @summary Update monitoring configuration
     * @param {string} tenantId Tenant ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringConfigurationApiInterface
     */
    updateMonitoringConfigurationRaw(requestParameters: UpdateMonitoringConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update monitoring configuration for a tenant
     * Update monitoring configuration
     */
    updateMonitoringConfiguration(requestParameters: UpdateMonitoringConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class MonitoringConfigurationApi extends runtime.BaseAPI implements MonitoringConfigurationApiInterface {

    /**
     * Disable Azure Monitor and Application Insights for a tenant
     * Disable Azure Monitor
     */
    async disableAzureMonitoringRaw(requestParameters: DisableAzureMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling disableAzureMonitoring().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/azure/disable/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Disable Azure Monitor and Application Insights for a tenant
     * Disable Azure Monitor
     */
    async disableAzureMonitoring(requestParameters: DisableAzureMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.disableAzureMonitoringRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disable Prometheus monitoring for a tenant
     * Disable Prometheus monitoring
     */
    async disablePrometheusMonitoringRaw(requestParameters: DisablePrometheusMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling disablePrometheusMonitoring().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/prometheus/disable/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Disable Prometheus monitoring for a tenant
     * Disable Prometheus monitoring
     */
    async disablePrometheusMonitoring(requestParameters: DisablePrometheusMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.disablePrometheusMonitoringRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enable Azure Monitor and Application Insights for a tenant
     * Enable Azure Monitor
     */
    async enableAzureMonitoringRaw(requestParameters: EnableAzureMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling enableAzureMonitoring().'
            );
        }

        if (requestParameters['instrumentationKey'] == null) {
            throw new runtime.RequiredError(
                'instrumentationKey',
                'Required parameter "instrumentationKey" was null or undefined when calling enableAzureMonitoring().'
            );
        }

        if (requestParameters['connectionString'] == null) {
            throw new runtime.RequiredError(
                'connectionString',
                'Required parameter "connectionString" was null or undefined when calling enableAzureMonitoring().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instrumentationKey'] != null) {
            queryParameters['instrumentationKey'] = requestParameters['instrumentationKey'];
        }

        if (requestParameters['connectionString'] != null) {
            queryParameters['connectionString'] = requestParameters['connectionString'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/azure/enable/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Enable Azure Monitor and Application Insights for a tenant
     * Enable Azure Monitor
     */
    async enableAzureMonitoring(requestParameters: EnableAzureMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.enableAzureMonitoringRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enables hybrid monitoring for a tenant, combining both Azure Monitor and Prometheus systems.  ### What Hybrid Monitoring Provides:  ** Best of Both Worlds:** - Azure Monitor for APM, distributed tracing, and smart detection - Prometheus for detailed metrics, Kubernetes integration, and Grafana dashboards - Unified monitoring strategy with configurable primary system  ** Metrics Routing:** - Application metrics sent to both systems simultaneously - Configurable primary monitoring system for alerting - Support for gradual migration between systems  ** Migration Support:** - Phase 1: Enable both systems in parallel - Phase 2: Migrate dashboards and alerting - Phase 3: Disable legacy system  ### Configuration Applied:  This endpoint automatically configures: 1. **Azure Monitor**: Enabled with provided credentials 2. **Prometheus**: Enabled with default settings (/actuator/prometheus, 30s scrape) 3. **Hybrid Settings**: Primary monitoring set to Prometheus, metrics routing to both  ### Prerequisites:  - Valid Azure Application Insights resource - Instrumentation key and connection string from Azure portal - Prometheus server configured to scrape the application 
     * Enable hybrid monitoring
     */
    async enableHybridMonitoringRaw(requestParameters: EnableHybridMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling enableHybridMonitoring().'
            );
        }

        if (requestParameters['instrumentationKey'] == null) {
            throw new runtime.RequiredError(
                'instrumentationKey',
                'Required parameter "instrumentationKey" was null or undefined when calling enableHybridMonitoring().'
            );
        }

        if (requestParameters['connectionString'] == null) {
            throw new runtime.RequiredError(
                'connectionString',
                'Required parameter "connectionString" was null or undefined when calling enableHybridMonitoring().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instrumentationKey'] != null) {
            queryParameters['instrumentationKey'] = requestParameters['instrumentationKey'];
        }

        if (requestParameters['connectionString'] != null) {
            queryParameters['connectionString'] = requestParameters['connectionString'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/hybrid/enable/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enables hybrid monitoring for a tenant, combining both Azure Monitor and Prometheus systems.  ### What Hybrid Monitoring Provides:  ** Best of Both Worlds:** - Azure Monitor for APM, distributed tracing, and smart detection - Prometheus for detailed metrics, Kubernetes integration, and Grafana dashboards - Unified monitoring strategy with configurable primary system  ** Metrics Routing:** - Application metrics sent to both systems simultaneously - Configurable primary monitoring system for alerting - Support for gradual migration between systems  ** Migration Support:** - Phase 1: Enable both systems in parallel - Phase 2: Migrate dashboards and alerting - Phase 3: Disable legacy system  ### Configuration Applied:  This endpoint automatically configures: 1. **Azure Monitor**: Enabled with provided credentials 2. **Prometheus**: Enabled with default settings (/actuator/prometheus, 30s scrape) 3. **Hybrid Settings**: Primary monitoring set to Prometheus, metrics routing to both  ### Prerequisites:  - Valid Azure Application Insights resource - Instrumentation key and connection string from Azure portal - Prometheus server configured to scrape the application 
     * Enable hybrid monitoring
     */
    async enableHybridMonitoring(requestParameters: EnableHybridMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableHybridMonitoringRaw(requestParameters, initOverrides);
    }

    /**
     * Enable Prometheus monitoring for a tenant
     * Enable Prometheus monitoring
     */
    async enablePrometheusMonitoringRaw(requestParameters: EnablePrometheusMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling enablePrometheusMonitoring().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/prometheus/enable/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Enable Prometheus monitoring for a tenant
     * Enable Prometheus monitoring
     */
    async enablePrometheusMonitoring(requestParameters: EnablePrometheusMonitoringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.enablePrometheusMonitoringRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns comprehensive information about all available monitoring options and their capabilities.  This endpoint provides a detailed overview of each monitoring type, including: - Feature descriptions and capabilities - Configuration requirements - Use case recommendations - Integration prerequisites  Use this endpoint to understand which monitoring approach best fits your needs before configuring monitoring for a tenant. 
     * Get available monitoring options
     */
    async getAvailableMonitoringOptionsRaw(requestParameters: GetAvailableMonitoringOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/options`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Returns comprehensive information about all available monitoring options and their capabilities.  This endpoint provides a detailed overview of each monitoring type, including: - Feature descriptions and capabilities - Configuration requirements - Use case recommendations - Integration prerequisites  Use this endpoint to understand which monitoring approach best fits your needs before configuring monitoring for a tenant. 
     * Get available monitoring options
     */
    async getAvailableMonitoringOptions(requestParameters: GetAvailableMonitoringOptionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAvailableMonitoringOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the complete monitoring configuration for a specific tenant.  This endpoint returns all monitoring configurations including Azure Monitor, Prometheus, Hybrid, and Telemetry settings. The configuration determines which monitoring systems are active and how they collect metrics from the application.  ### Configuration Types Returned: - **azure**: Azure Monitor and Application Insights configuration - **prometheus**: Prometheus metrics collection configuration - **hybrid**: Combined monitoring system configuration - **telemetry**: Custom telemetry and business metrics configuration  ### Configuration Inheritance: The returned configuration follows inheritance rules: 1. System-wide defaults (if no tenant-specific config exists) 2. Tenant-specific overrides (if configured) 3. Effective configuration (computed result) 
     * Get monitoring configuration
     */
    async getMonitoringConfigurationRaw(requestParameters: GetMonitoringConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getMonitoringConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/configuration/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retrieves the complete monitoring configuration for a specific tenant.  This endpoint returns all monitoring configurations including Azure Monitor, Prometheus, Hybrid, and Telemetry settings. The configuration determines which monitoring systems are active and how they collect metrics from the application.  ### Configuration Types Returned: - **azure**: Azure Monitor and Application Insights configuration - **prometheus**: Prometheus metrics collection configuration - **hybrid**: Combined monitoring system configuration - **telemetry**: Custom telemetry and business metrics configuration  ### Configuration Inheritance: The returned configuration follows inheritance rules: 1. System-wide defaults (if no tenant-specific config exists) 2. Tenant-specific overrides (if configured) 3. Effective configuration (computed result) 
     * Get monitoring configuration
     */
    async getMonitoringConfiguration(requestParameters: GetMonitoringConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getMonitoringConfigurationRaw(requestParameters, initOverrides);
    }

    /**
     * Get current monitoring status for a tenant
     * Get monitoring status
     */
    async getMonitoringStatusRaw(requestParameters: GetMonitoringStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getMonitoringStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/status/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get current monitoring status for a tenant
     * Get monitoring status
     */
    async getMonitoringStatus(requestParameters: GetMonitoringStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getMonitoringStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Migrate from one monitoring system to another
     * Migrate monitoring system
     */
    async migrateMonitoringSystemRaw(requestParameters: MigrateMonitoringSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling migrateMonitoringSystem().'
            );
        }

        if (requestParameters['fromType'] == null) {
            throw new runtime.RequiredError(
                'fromType',
                'Required parameter "fromType" was null or undefined when calling migrateMonitoringSystem().'
            );
        }

        if (requestParameters['toType'] == null) {
            throw new runtime.RequiredError(
                'toType',
                'Required parameter "toType" was null or undefined when calling migrateMonitoringSystem().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fromType'] != null) {
            queryParameters['fromType'] = requestParameters['fromType'];
        }

        if (requestParameters['toType'] != null) {
            queryParameters['toType'] = requestParameters['toType'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/migrate/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Migrate from one monitoring system to another
     * Migrate monitoring system
     */
    async migrateMonitoringSystem(requestParameters: MigrateMonitoringSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.migrateMonitoringSystemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test connectivity for a specific monitoring type
     * Test monitoring connectivity
     */
    async testMonitoringConnectivityRaw(requestParameters: TestMonitoringConnectivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling testMonitoringConnectivity().'
            );
        }

        if (requestParameters['monitoringType'] == null) {
            throw new runtime.RequiredError(
                'monitoringType',
                'Required parameter "monitoringType" was null or undefined when calling testMonitoringConnectivity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['monitoringType'] != null) {
            queryParameters['monitoringType'] = requestParameters['monitoringType'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/test/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Test connectivity for a specific monitoring type
     * Test monitoring connectivity
     */
    async testMonitoringConnectivity(requestParameters: TestMonitoringConnectivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.testMonitoringConnectivityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update monitoring configuration for a tenant
     * Update monitoring configuration
     */
    async updateMonitoringConfigurationRaw(requestParameters: UpdateMonitoringConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateMonitoringConfiguration().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateMonitoringConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/monitoring/configuration/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update monitoring configuration for a tenant
     * Update monitoring configuration
     */
    async updateMonitoringConfiguration(requestParameters: UpdateMonitoringConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateMonitoringConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
